import { TCalculationActiveInfo } from '../../types/calculation-common';
import * as actions from './actions';
import * as getters from './getters';
import * as mutations from './mutations';

export default {
  namespaced: true,
  getters,
  mutations,
  actions,
  state: {
    uploadingDataStatus: {
      isProgress: true,
    } as TCalculationActiveInfo,
  },
};
